import getObjectIds from "../utils/getObjectIds";
import {Identifiable} from "../../../eobiekt-react/src/sale/models/Identifiable";

declare const config: { API_URL: string };

export const API_URL = (config && config.API_URL) || "http://localhost:8085/tt-rest";

export const GET_RESERVATION_CONFIG = "/reservation/web/config";
export const LOGIN_OPERATOR_URL = "/crud/webLogin/user/password/new";
export const REGISTER_WEBUSER = "/crud/webLogin/int/new";
export const RESET_PASSWORD = "/crud/webLogin/resetPassword";
export const GET_BILL_BY_WEBUSER = "/bill/webUser";
export const GET_PASSES_BY_WEB_LOGIN = (webUserIds: string) => `/crud/webLogin/passes?webUserIds=${webUserIds}`;
export const GET_EXERCISE_BY_DATE = "/crud/exercise/dates/v2";
export const GET_EXERCISE_DETAILS = (exerciseIds: string) => `/crud/exercise/sale/details?ids=${exerciseIds}`;
export const GET_ALL_EXERCISE_GROUP = "/crud/exerciseGroup";
export const GET_ALL_ZONE = "/crud/zone";
export const ACTIVE_WEB_LOGIN = "/crud/webLogin/activate";
export const GET_TICKET_BY_EXERCISEGROUP = "/crud/assort/ticket/active/internet/byExerciseGroup";
export const CREATE_NEW_BILL = "/admin_creat_new_bill";
export const EXERCISE_SAVE_RESERVATION = "/bill/simpleReservation";
export const GET_EXERCISE_BY_SEAT_SALE = "/exercise/cinema";
export const GET_TICKET_BY_EXERCISE_ON_SEAT_SALE = (exerciseIds: string) => {
  const objectIds = getObjectIds(exerciseIds);
  return `/ticket/exercise/${objectIds?.objectDb}/${objectIds?.objectId}`;
};
export const GET_TICKET_FOR_EXERCISE_BY_SEATS = (exerciseIds: string, seatIds: string) =>
    `/ticket/exercise/V2?exerciseIds=${exerciseIds}&seatIds=${seatIds}&isInternet=true`;
export const GET_ZONE_SCHEME_BY_EXERCISE = "/exercise/ZoneScheme/V2";
export const GET_ZONE_BY_EXERCISE_AND_DATE = (date: string) => `/crud/zone/exercise?date=${date}`;
export const GET_EXERCISE_GROUP_BY_EXERCISE_AND_DATE = (date: string) => `/crud/exerciseGroup/ByDate?date=${date}`;
export const REFRESH_ACCOUNT_BY_TOKEN = "/crud/webLogin/refresh";
export const GET_DEPOSIT_DEFINITION = "/crud/accountDepositDefinition/int";
export const SAVE_DEPOSIT_DEFINITION = "/crud/account/registerIncome";
export const GET_EXERCISE_BY_ID = (exerciseIds: string) => {
  const objectIds = getObjectIds(exerciseIds);
  return `/crud/exercise/${objectIds?.objectId}/${objectIds?.objectDb}`;
};
export const BLOCK_SEAT = (exerciseIds: Identifiable, seatIds: Identifiable) =>
    `/seat/block/${exerciseIds?.objectId}/${exerciseIds?.objectDb}/${seatIds?.objectId}/${seatIds?.objectDb}`;
export const UNBLOCK_SEAT = (exerciseIds: Identifiable, seatIds: Identifiable) =>
    `/seat/unBlock/seat/${exerciseIds?.objectId}/${exerciseIds?.objectDb}/${seatIds?.objectId}/${seatIds?.objectDb}`;
export const SAVE_CUSTOMER = "/crud/customer/validate";
